module.exports = __webpack_public_path__ + "media/images/neuroscience-136c81253594be7c19855006a8c2fd6a.png";